<template>

  <div class="vpay__payment-frequency">

    <div class="vpay__input-container">
      <label>How often do you want to give?</label>
      <SplitButtons
        :buttons="[ { key: 'one_time', label: 'One Time' }, { key: 'recurring', label: 'Recurring' } ]"
        v-model="$store.state.frequency.type"
      />
      <p
        v-if="!$store.getters.userIsLoggedIn && $store.state.frequency.type === 'recurring'"
        class="vpay__input-note"
      >You will need to create an account or login to make a recurring payment.</p>
    </div>

    <div
      v-if="$store.state.frequency.type === 'recurring'"
      class="vpay__interval"
    >

      <div class="vpay__input-container">
        <SplitButtons
          :buttons="[ { key: 'weekly', label: 'Weekly' }, { key: 'fortnightly', label: 'Fortnightly' }, { key: 'monthly', label: 'Monthly' } ]"
          v-model="$store.state.frequency.interval"
        />
      </div>

      <div class="vpay__input-container">
        <label>Starting on</label>
        <Datepicker
          input-class="vpay__input vpay__input--small"
          calendar-class="vpay__calendar"
          v-model="$store.state.frequency.startDate"
          format="dd MMMM yyyy"
          :disabled-dates="disabledDates"
          :full-month-name="true"
        />
      </div>

    </div>

  </div>

</template>

<script>
import SplitButtons from "@/components/SplitButtons";

import Datepicker from "vuejs-datepicker";

export default {
  name: "PaymentFrequency",

  components: { SplitButtons, Datepicker },

  data() {
    return {
      interval: "weekly",

      startingOn: new Date(),

      disabledDates: { to: new Date() },
    };
  },
};
</script>

<style>
</style>
